import useSelector from '@app/hooks/useSelector';

import { getIntegrations } from '../../reducers/downloadData/selectors';
import type { TriggersProps } from './Triggers';
import Triggers from './Triggers';
import TriggersPromo from './components/TriggersPromo';

type TriggersContainerProps = TriggersProps & {
    projectId: string;
};

const TriggersContainer = ({ projectId, ...rest }: TriggersContainerProps) => {
    const integrations = useSelector(getIntegrations);
    const hasIntegrations = !!integrations && !!Object.keys(integrations).length;

    if (!hasIntegrations) {
        return (
            <section aria-label="Triggers promo card">
                <TriggersPromo projectId={projectId} />
            </section>
        );
    }

    return (
        <section aria-label="Apps triggers">
            <Triggers {...rest} projectId={projectId} />
        </section>
    );
};

export default TriggersContainer;
